
import { Options, Vue } from 'vue-class-component'

@Options({
  props: {
    label: String
  },
  computed: {
    cssVars() {
      return {
        '--background-image': 'url(' + require('@/assets/patreon-banner.webp') + ')'
      }
    }
  }
})
export default class PatreonButton extends Vue {
  label!: string
}
